export default "__VITE_ASSET__Db3nk9o2__"